import { UniAbcState } from "@/store/uniabc/state";
import { getStoreAccessors } from "typesafe-vuex";
import { State as RootState } from "@/store/state";

export const getters = {
  getEntries: (state: UniAbcState) => state.entries,

  getEntryByLabel: (state: UniAbcState) => (label: string) => {
    return state.entries[label];
  },

  getReferencesOfLabel: (state: UniAbcState) => (label: string) => {
    return state.entries[label].refs;
  },

  isEmpty: (state: UniAbcState) => () => Object.keys(state.entries).length <= 0,

  getLastLoad: (state: UniAbcState) => state.lastLoad,

  getEntriesArray: (state: UniAbcState) => () =>
    Object.keys(state.entries)
      .map(e => state.entries[e])
      .sort((a, b) => (a.label > b.label ? 1 : -1)),

  getFLCID: (state: UniAbcState) => state.fileLastCommitId,

  getApprovalsOfLabel: (state: UniAbcState) => (label: string) => {
    return state.entries[label].lastApproved;
  },

  getSectionsString: (state: UniAbcState) => () =>
    [
      ...new Set(
        getters
          .getEntriesArray(state)()
          .map(e => e.section)
      )
    ].sort()
};

const { read } = getStoreAccessors<UniAbcState, RootState>("");

export const readEntries = read(getters.getEntries);
export const readEntryByLabel = read(getters.getEntryByLabel);
export const readReferencesOfLabel = read(getters.getReferencesOfLabel);
export const readEntriesIsEmpty = read(getters.isEmpty);
export const readLastLoad = read(getters.getLastLoad);
export const readEntriesArray = read(getters.getEntriesArray);
export const readFLCID = read(getters.getFLCID);
export const readSectionsString = read(getters.getSectionsString);
